// pages/Users/ManageUsers.js
import React, { useState, useEffect } from "react";
import ListUsers from "./ListUsers";
import AddUser from "./AddUser";
import { Tabs, Tab, Box, Typography, Paper, Divider, useTheme } from "@mui/material";

export default function ManageUsers() {
  const [activeTab, setActiveTab] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    document.title = "Manage Users | KlonIT Web Application";
  }, []);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const triggerRefresh = () => {
    setRefresh((prev) => !prev);
  };

  return (
    <Paper
      sx={{
        p: 3,
        mt: 10,
        mx: "auto",
        maxWidth: "1200px",
        bgcolor: "background.paper",
        boxShadow: theme.palette.mode === "dark" ? 4 : 2,
      }}
    >
      {/* Page Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h4" color="text.primary">
          Manage <strong>Users</strong>
        </Typography>
      </Box>

      <Divider sx={{ mb: 3, borderColor: "divider" }} />

      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          aria-label="user management tabs"
          textColor="primary"
          indicatorColor="primary"
          sx={{
            '& .MuiTab-root': {
              alignItems: 'flex-start',
              textAlign: 'left',
              px: 3,
              py: 2,
              justifyContent: 'flex-start',
              color: `${theme.palette.text.primary} !important`,
              transition: 'all 0.2s ease',
              minHeight: 48,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
              '& .MuiSvgIcon-root': {
                color: theme.palette.text.primary,
              },
              '& .MuiTab-wrapper': {
                color: theme.palette.text.primary,
              },
            },
            '& .MuiTab-root.Mui-selected': {
              color: `${theme.palette.primary.main} !important`,
              backgroundColor: theme.palette.action.selected,
              fontWeight: 'bold',
              '& .MuiSvgIcon-root': {
                color: theme.palette.primary.main,
              },
              '& .MuiTab-wrapper': {
                color: theme.palette.primary.main,
              },
            },
          }}
        >
          <Tab label="List Users" />
          <Tab label="Add User" />
        </Tabs>
      </Box>

      {/* Tab Panels */}
      <Box sx={{ mt: 3 }}>
        {activeTab === 0 && <ListUsers refresh={refresh} onRefresh={triggerRefresh} />}
        {activeTab === 1 && <AddUser onRefresh={triggerRefresh} />}
      </Box>
    </Paper>
  );
}
